export const testimonials = [
  {
    name: 'Fred',
    desc: 'Founder of QQPay & Buzzme',
    testimony: [
      `"Partnering with Active Tech Ltd on QQPay
    & BuzzMe App was exceptional. Their technical expertise and
    dedication to our vision were outstanding."`,
      `"I highly recommend the team to any organization seeking to
      create innovative solutions worldwide."`,
    ],
  },
  {
    name: 'Tobi Olusola',
    desc: 'Founder Ilerah',
    testimony: [
      `"Working with Active Tech's software engineers was pivotal for Ilerah. Their expert team played a crucial role in developing our health tech platform, ensuring quality and innovation. I highly recommend Active Tech for their exceptional engineering talent and dedication."`,
    ],
  },
  // {
  //     name: '',
  //     desc: '',
  //     testimony: [
  //         '',
  //         '',
  //     ],
  // }
];
